import {
	instance
} from '../../util/http'
import apis from '../../config/apis'
// 查询用户店长审批记录  （店长审批查询分页）
const GetUserApprovalsApprovalsList = (SaleStatus,Page, PageSize) => {
	return instance.get(apis.OwnerApproval.GetUserApprovals + "?SaleStatus=" + SaleStatus +  "&Index=" + Page + "&Size=" + PageSize)
}

 

export default {
	GetUserApprovalsApprovalsList
}